import { isoString, timezoneOffsetTicks } from "./dates"

export async function fetchJSON(url, options) {
    const response = await fetch(url, options)
    if (!response) throw { title: "Service not available", text: "The server is not responding. Please try again at a later time." }
    if (!response.ok) throw { title: "Service not available", text: `Please try again at a later time. [${response.status}]` }

    const data = await response.json()
    if (!data) throw { title: "Service not available", text: "The endpoint is not responding. Please try again at a later time." }
    if (data.exception || data.error) throw data

    return fixFetchedData(data)
}

export async function queryJSON(url, data, options) {
    if (data) url += (!url.includes('?') ? '?' : '&') + createBody(data, new URLSearchParams)

    return fetchJSON(url, options)
}

export async function postJSON(url, post, postAs) {
    let options = { method: "POST" }

    let body = options.body = createBody(post, postAs)
    if (body && !(body instanceof FormData || body instanceof URLSearchParams)) {
        //  Only send Content-Type when body is plain text.
        //  FetchAPI will set it for us if body is one of the above two types.
        options.headers = { 'Content-Type': 'application/json' }
    }

    return fetchJSON(url, options)
}

export function createBody(post, postAs) {
    if (postAs instanceof FormData || postAs instanceof URLSearchParams)
        return convertPost(post, postAs)

    if (post instanceof FormData || post instanceof URLSearchParams)
        return post

    return convertPost(post)
}

export function convertPost(post, target) {
    if (!post) return post

    if (!target) {
        post = fixPostData(post)
        return JSON.stringify(post)
    }
    else if (target instanceof FormData || target instanceof URLSearchParams) {
        for (let key in post) {
            let entry = post[key]
            if (entry == null || typeof entry !== 'object' || typeof entry[Symbol.iterator] !== 'function') {
                if (typeof entry === 'boolean') {
                    entry = entry ? 'on' : ''
                }
                if (entry == null) {
                    entry = ''
                }
                else if (entry instanceof Date) {
                    entry = isoString(entry)
                }

                target.append(key, entry)
            }
            else for (let value of entry) {
                target.append(key, value)
            }
        }
        return target
    }
}

export function fixFetchedData(data) {
    if (typeof (data) !== "object" || data === null) return data

    //  Convert IDictionary<string, ???> into normal JS Objects
    if (data && data.constructor === Array && data.length) {
        //  Check that everything is an object with a Key and a Value property
        if (data.filter(obj => obj == null || typeof (obj) !== "object" || !obj.hasOwnProperty("Key") || !obj.hasOwnProperty("Value")).length == 0) {
            //  Check that every object has only those two keys and the Key value is always a string
            if (data.filter(obj => Object.keys(obj).length != 2 || typeof (obj["Key"]) !== "string").length == 0) {
                //  If so, convert the Array into an Object. Order of entires should in theory be preserved
                data = data.reduce((o,v) => (o[v.Key] = v.Value, o), {})
            }
        }
    }

    //  Look for DateTime-formatted strings and convert them into normal JS Dates
    for (let key of Object.keys(data)) {
        let value = data[key], type = typeof (value)

        if (type === "object") {
            data[key] = fixFetchedData(value)
        }
        else if (type === "string" && value.slice(0, 6) == "/Date(") {
            data[key] = fromMSDate(value)
        }
    }

    return data
}

export function fixPostData(data) {
    if (typeof (data) !== "object" || data === null) return data

    //  Look for JS Dates and convert them into DateTime-formatted strings
    for (let key of Object.keys(data)) {
        let value = data[key]

        if (typeof value === "object") {
            if (value instanceof Date) {
                data[key] = toMSDate(value)
            }
            else {
                data[key] = fixPostData(value)
            }
        }
    }

    return data
}

export function toMSDate(date) {
    //  Send a local-time date in UTC-ticks and include the browser's timezone
    if (date && (date instanceof Date)) {
        return `/Date(${Number(date)-timezoneOffsetTicks}${date.toTimeString().slice(12, 17)})/`
    }
}

export function fromMSDate(dateString) {
    //  Return a local-time Date based on the intended UTC time of the incoming, timezoned date string
    let match = /\/Date\(([+-]?\d+)(([+-]\d{2})(\d{2}))?\)\//.exec(dateString)
    if (match) {
        let [, TS, , H, M] = match.map(n => n - 0)
        return new Date(TS + (60 * H + M) * 60000 + timezoneOffsetTicks)
    }
}